import { useCallback, useState } from 'react';
import getDealStatuses from '../../api/deals/getDealStatuses';
import Select from '../Select/Select';

// Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸ Ð² ÑÐ¸Ð»ÑÑÑÐµ ÑÐ¿Ð¸ÑÐºÐ° Ð»Ð¸Ð´Ð¾Ð²: Ð²ÑÐµ ÑÑÐ°ÑÑÑÑ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ°, Ð±ÐµÐ· Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸ Ðº ÑÐ¾ÑÐ¼Ðµ Ð¾Ð¿Ð»Ð°ÑÑ
// (Ð² Ð¾ÑÐ»Ð¸ÑÐ¸Ðµ Ð¾Ñ SelectDealStatuses, ÐºÐ¾ÑÐ¾ÑÑÐ¹ ÑÑÐ¶Ð°ÐµÑ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¿Ð¾Ð´ ÑÐ¾ÑÐ¼Ñ Ð¾Ð¿Ð»Ð°ÑÑ ÑÐ´ÐµÐ»ÐºÐ¸).
const SelectLeadDealStatus = ({ handleSetSelect, handleSetState, style, ...props }) => {
  const [options, setOptions] = useState([]);
  const onFocus = useCallback(() => {
    getDealStatuses().then((res) => setOptions((res.data || []).map((item) => ({ value: item.id, label: item.title }))));
  }, []);

  return (
    <Select
      handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
      handleSetState={handleSetState}
      options={options}
      title={'Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸'}
      placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸'}
      onFocus={onFocus}
      style={style}
      {...props}
    />
  );
};

export default SelectLeadDealStatus;
